import UndoSlateButton from './UndoSlateButton'
// Uncomment the below to migrate to stateful component
// import UndoSlateButtonContainer from './UndoSlateButtonContainer'

export { UndoSlateButton }
export default UndoSlateButton
// Uncomment the below to migrate to stateful component
// export { UndoSlateButton, UndoSlateButtonContainer }
// export default UndoSlateButtonContainer



// WEBPACK FOOTER //
// ./src/components/UndoSlateButton/index.js